import {P} from 'components/atoms/Text/P';
import * as React from 'react';
import {FormattedMessage} from 'react-intl';

import './style.scss';

interface Props {
    timelineItem: { status: number };
    headlineId: string;
    descriptionId: string;
    children: React.ReactNode;
}

export const TimelineItem: React.FunctionComponent<Props> = ({timelineItem, headlineId, descriptionId, children}) => {

    const getTimelineStatusClass = (status: number) => {
        switch (status) {
            case 1:  return 'project-calendar__item project-calendar__item--current';// current = 1
            case -1: return 'project-calendar__item project-calendar__item--passed';// passed = -1
            default:
                return 'project-calendar__item';// future = 0
        }
    };

    return (
        <div className={getTimelineStatusClass(timelineItem.status)}>
            <P>
                <strong><FormattedMessage id={headlineId} /></strong>
                <br/>
                <span className="tiny">
                    {children}
                    <br/>
                </span>
                <FormattedMessage id={descriptionId} />
            </P>
            <span className="project-calendar__marker"></span>
        </div>
    )
};
